import React from "react";
import { Path } from "enums";
import { Route, Switch, Redirect } from "react-router-dom";
import PayWithPesoModule from "modules/plc/pay-with-peso/pay-with-peso.module";

const PayWithPesoPage = () => {
  return (
    <Switch>
      <Route exact path={Path.PayWithPeso} component={PayWithPesoModule} />
      <Redirect to={Path.PayWithPeso} />
    </Switch>
  );
};

export default PayWithPesoPage;
